import {BonusEntitlement, BonusEntitlementType} from "../domain/BonusEntitlement";
import React, {Key, useState} from "react";
import {Card, Chip, Icon, Stack, Tooltip, Typography} from "@mui/material";
import {AutoStories, Draw, HelpOutline, HourglassBottomRounded, PlayCircle, StopCircle, CalendarMonth} from "@mui/icons-material";
import {grey, red} from "@mui/material/colors";
import {formatISO, intlFormat, isFuture} from "date-fns";
import {HealthRating} from "../domain/HealthRating";
import {healthRatingLightColor} from "../util/HealthStatusUtils";

interface BonusEntitlementProps {
    bonusEntitlement:BonusEntitlement;
}

const iconColor = grey[700];

const lookupBonusEntitlementIcon = (bonusEntitlementType: BonusEntitlementType) => {
    if (bonusEntitlementType === BonusEntitlementType.STORY) {
        return <AutoStories  sx={{color: iconColor}}/>
    } else if (bonusEntitlementType === BonusEntitlementType.ACTIVITY) {
        return <Draw sx={{color: iconColor}} />
    } else {
        return <HelpOutline sx={{color: iconColor}}/>
    }
}


export default function BonusEntitlementDisplay({bonusEntitlement}: BonusEntitlementProps) {

    const backgroundColor = isFuture(bonusEntitlement.from) ? healthRatingLightColor(HealthRating.WARNING) : grey[50];

    return (
        <Card sx={{p: 0.5, mr: 0.5, background: backgroundColor}}>
            <Stack spacing={0.5}>
                <Stack direction={"row"} spacing={0.5} alignItems="center">
                    {lookupBonusEntitlementIcon(bonusEntitlement.type)}
                    <Typography variant="caption">{bonusEntitlement.content}</Typography>
                </Stack>
                <Stack direction={"row"} spacing={0.5} alignItems="center">
                    <CalendarMonth sx={{color: iconColor}}/>
                    <Tooltip title={formatISO(bonusEntitlement.from)}>
                    <Typography variant="caption">{
                        formatISO(bonusEntitlement.from, { representation: 'date'})}</Typography>
                    </Tooltip>
                </Stack>
            </Stack>

        </Card>
    );
}